import React from 'react';
import $i18n from '@/i18n';
import UrlsContent from './urlsContent';
import DarkToolTip from '@/components/DarkToolTip';

const tipRenderCell = (v) => (
  <DarkToolTip
    lineCount={1}
    placement="topLeft"
    arrow={{ pointAtCenter: true }}
    triggerContent={v}
    content={v}
  />
);

export const tableColumons = [
  {
    title: $i18n.get({ id: 'aopf.component.MiniappsRedirectURL.UrlName', dm: 'URL 名称' }),
    dataIndex: 'urlName',
    width: '25%',
    cell: tipRenderCell,
  },
  {
    title: 'URL',
    dataIndex: 'urls',
    cell: (_value) => {
      // const arr = _value?.split(',') || [];
      // const children = (
      //   <div>
      //     {arr.map((vv) => (
      //       <div style={{ color: '#585F7E', lineHeight: '20px', wordBreak: 'break-all' }}>{vv}</div>
      //     ))}
      //   </div>
      // );
      return <UrlsContent value={_value} />;
    },
    width: '50%',
  },
  {
    title: $i18n.get({ id: 'aopf.detail.redirectUrl.config.Description', dm: '描述' }),
    dataIndex: 'description',
    cell: tipRenderCell,
    width: '35%',
  },
];
